import { CLMLinkPrimaryArrow } from "components/CLM/v3/Buttons";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { BsArrowRight } from "react-icons/bs";

const CustomerCard = ({
  imageSrc,
  customerName,
  customerDescription,
  bgColor,
  isCaseStudy,
  customerKey,
}) => {
  return (
    <div
      className={`w-full h-[470px] flex flex-col items-center justify-between rounded-xl overflow-hidden mt-3  border border-gray-300 transition-all duration-500 ease-in-out bg-white`}
    >
      <div
        className={`w-full h-[225px] flex justify-center items-center overflow-hidden`}
      >
        <Image
          src={imageSrc}
          loading="lazy"
          alt={customerName}
          width="350"
          height="350"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="w-full h-60 flex flex-col justify-between items-start p-7 pt-0">
        <div className="flex flex-col justify-between items-start">
          <h1 className="text-2xl font-semibold mt-4">{customerName}</h1>
          <p className="text-base mt-2">{customerDescription}</p>
        </div>
        <CLMLinkPrimaryArrow
          buttonUrl={
            isCaseStudy && customerKey
              ? `/signature/case-studies/${customerKey}`
              : `/customers/${customerName.replaceAll(" ", "")}`
          }
          buttonText={"Read Testimonial"}
        />
        {/* <Link
          href={
            isCaseStudy && customerKey
              ? `/signature/case-studies/${customerKey}`
              : `/customers/${customerName.replaceAll(" ", "")}`
          }
          className="flex items-center gap-1 bg-white text-black border border-black rounded-full py-2 px-6 w-fit group-hover:bg-black group-hover:text-white transition-all duration-500 ease-in-out"
        >
          Read Testimonial{" "}
          <BsArrowRight className="text-2xl text-black group-hover:text-white" />
        </Link> */}
      </div>
    </div>
  );
};

export default CustomerCard;
